import { render, staticRenderFns } from "./ModalNewProvider.vue?vue&type=template&id=720e2e4a"
import script from "./ModalNewProvider.vue?vue&type=script&lang=js"
export * from "./ModalNewProvider.vue?vue&type=script&lang=js"
import style0 from "./ModalNewProvider.vue?vue&type=style&index=0&id=720e2e4a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720e2e4a')) {
      api.createRecord('720e2e4a', component.options)
    } else {
      api.reload('720e2e4a', component.options)
    }
    module.hot.accept("./ModalNewProvider.vue?vue&type=template&id=720e2e4a", function () {
      api.rerender('720e2e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalNewProvider.vue"
export default component.exports